import { render, staticRenderFns } from "./AccountBox.vue?vue&type=template&id=f24c3fba&"
import script from "./AccountBox.vue?vue&type=script&lang=js&"
export * from "./AccountBox.vue?vue&type=script&lang=js&"
import style0 from "./AccountBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports